import React from 'react'
import { Typography } from 'antd'
import styles from './index.module.scss'
import TemplateBadge from '@app/pages/adminSettings/MessageTemplateManagement/MessageTemplates/TemplateBadge'

const { Text } = Typography

const SuggestionItem = ({ template, index, onSelect, isUnifiedConversation }) => {
  return (
    <div
      key={template.id || index}
      className={styles.suggestionItem}
      onClick={() => onSelect(template)}
    >
      <div className={styles.suggestionContent}>
        <div className={styles.suggestionHeader}>
          <Text strong className={styles.templateName}>
            {template.name}
          </Text>
          <TemplateBadge
            template={template}
            showAudience={true}
            showPreApproval={true}
            isUsingUnifiedConvo={isUnifiedConversation}
            size="small"
            visibleAudienceBadges={isUnifiedConversation ? null : ['internal']}
          />
        </div>
        <Text className={styles.templateText} ellipsis={{ rows: 2 }}>
          {template.text}
        </Text>
      </div>
    </div>
  )
}

export default SuggestionItem
